// extracted by mini-css-extract-plugin
module.exports = {"title":"ContentCardTitle_title__1sjr8"};